/* eslint-disable array-callback-return */
import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, Button, Grid } from "@material-ui/core";
import expandarrow from "../../assets/icons8-expand-arrow.svg";
import { CommonTable } from "../../components";
import { SearchWithFilter } from "../../components";
import GenerateFormVersion2 from "../../components/common/smartForm/genreateFormversion2";
import { YearPicker } from "../../components/common/smartForm/component/YearPicker";
import { Row, Col } from "qdm-component-library";
import { FilterSelect } from "./filterSelect";
import { useDispatch, useSelector } from "react-redux";
import { actions, async } from "primary_care_admin_binder";
import { withAllContexts } from "../../HOCs";
import moment from "moment";
import { connect } from "react-redux";
import { extractIdAndValue } from "../../utils";
import { format, set } from "date-fns";
import { disable } from "workbox-navigation-preload";
import Config from "../../config";
import { AxiosCall } from "../../utils";
import axios from "axios";
import { EnvContext } from "../../contexts";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    marginLeft: "18px",
    width: "97%",
    border: "1px solid lightgrey",
    borderRadius: "2px",
  },
  leftButton: {
    border: "none",
    backgroundColor: "#fff",
    width: 32,
    height: 32,
    borderRadius: "50%",
    cursor: "pointer",
  },
  addNewModal: {
    padding: "15px",
    width: "86%",
    height: "230px",
  },
  entityAdd: {
    padding: "15px",
    width: "86%",
    height: "700px",
  },
  copyYearModal: {
    padding: "18px",
    width: "27%",
    height: "230px !important",
  },
  copyNote: {
    border: "none",
    color: "#0071F2",
    textDecoration: "underline",
    backgroundColor: "#ffffff",
    fontSize: "15px",
    fontFamily: "poppin",
    cursor: "pointer",
    paddingRight: 10,
    paddingBottom: 9,
    paddingLeft: 20,
  },
  confirmNote: {
    border: "none",
    color: "#ff5c5a",
    borderRadius: 5,
    background: "#fff2f2",
    fontSize: "15px",
    fontFamily: "poppin",
    cursor: "pointer",
    padding: 6,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0px 21px 0px 15px",
  },
  saveBtn: {
    padding: "6px 20px",
    borderRadius: 7,
    textTransform: "none !important",
    fontSize: 16,
    fontFamily: "pc_semibold",
    background: "#0071f2",
    color: "#fff",
    "&:hover": {
      background: "#0071f2",
    },
  },
  pickYear: {
    width: 380,
  },
}));

function HolidayTableVersion2(props) {
  const { parent_id } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const listData = useSelector(
    (state) => state?.holidaySlice?.holiday_qdm?.data
  );
  const { envConfig } = useContext(EnvContext);
  // const master = useSelector(
  //   (state) => state?.holidaySlice?.holiday_master?.data
  // );
  // work in progress
  const EntityMasters = useSelector(
    (state) => state?.holidaySlice?.entity_master.data
  );
  const EditMaster = useSelector(
    (state) => state?.holidaySlice?.holidaySinglereadqdm
  );

  const Entityreadqdm = useSelector(
    (state) => state?.holidaySlice?.entity_read_qdm.data
  );

  const EditMasters = useSelector(
    (state) => state?.holidaySlice?.holidaySinglereadSelectedqdm
  );

  const GetWeekday = useSelector(
    (state) => state?.holidaySlice?.holidayAllWeekdayqdm?.data
  );

  // const upsertDatas = useSelector(
  //   (state) => state?.holidaySlice?.holiday_upsert?.data
  // );

  // const HolidaySingleRead = useS

  const saveloading = useSelector(
    (state) => state?.holidaySlice?.holiday_upsert?.loading
  );

  const getHolidayType = useSelector(
    (state) => state?.holidaySlice?.holidayType?.data
  );
  const [Thdata, setThdata] = React.useState([]);
  const [holidayType, setholidayType] = React.useState();
  const [allMasters, setAllMasters] = React.useState();
  const [perPage, setPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [isAdd, setIsAdd] = React.useState(true);
  const [editId, setEditId] = React.useState("");
  const [copyNewHolidayYear, setCopyNewHolidayYear] = React.useState(false);
  const [copyYear, setCopyYear] = React.useState(false);
  const [clicked, setClicked] = React.useState(true);
  const [showStatus, setShowStatus] = React.useState(false);
  const [treeData, setTreeData] = React.useState();
  const [treeListData, setTreeListData] = React.useState([]);
  const [controler, setControler] = React.useState(false);
  const [showFacility, setShowFacility] = React.useState(true);
  const [currentYear, setCurrentYear] = React.useState(moment().year());
  const [refresh, setRefresh] = React.useState(false);
  const [calendarYear, setConfirmCalenderYear] = React.useState({
    copy_calander_year: "",
  });
  const [copyYearData, setCopyYearData] = React.useState([]);
  const [copiedData, setCopiedData] = React.useState([]);
  const [isEdit, setIsEdit] = React.useState(false);
  const [master, setmaster] = React.useState([]);
  const [valueDef, setValueDef] = React.useState([]);
  const [id, setId] = React.useState("");
  const [values, setValues] = React.useState([]);
  const [state, setState] = React.useState({
    holiday_reason: "",
    holiday_type: {},
    date: "",
    repeat: true,
  });
  const [filterData, setFilterData] = React.useState({
    entity_type: {},
    entity_name: {},
  });
  const [show, setshow] = React.useState(false);
  const [view, setview] = React.useState("");

  const [disableSave, setDisableSave] = React.useState(false);

  useEffect(() => {
    dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,
      })
    );
  }, [currentYear, dispatch, page, perPage]);
  const AppointmentTypeUpdsert = useSelector(
    (state) => state?.resourceByAppointmentTypesSlice.table_add
  );
  // useEffect(() => {
  //   dispatch(actions.HOLIDAY_UPSERT(copyYearData));
  // }, [copyYearData, dispatch]);

  useEffect(() => {
    dispatch(actions.HOLIDAY_SINGLE_READ_QDM(editId));
    dispatch(actions.HOLIDAY_SINGLE_READ_SELECTED_QDM(editId));
  }, [editId]);
  const handlepageChange = async (currentPage, PerPage) => {
    setPage((currentPage - 1) * PerPage);
    setPerPage(PerPage);
    await dispatch(
      actions.HOLIDAY_READ_QDM({
        page: (currentPage - 1) * PerPage,
        perPage: PerPage,
        CalYear: currentYear,
      })
    );
  };

  useEffect(() => {
    dispatch(actions.GET_HOLIDAY_ALL_WEEKDAYS_QDM());
  }, []);

  const getallmasters = async () => {
    await dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,
      })
    );
    const data = await props.PRACTITIONER_MASTERS();
    setAllMasters(data?.payload?.data);
  };
  // const Thdata = [
  //   {
  //     Title: "Entity",
  //     Size: 9,
  //   },
  //   {
  //     Title: "Status",
  //     Size: 3,
  //   },
  // ];
  const getEntityTree = async () => {
    const data = await dispatch(actions.HOLIDAY_ENTITY_MASTERS_QDM(editId));
    if (!data.payload.error) {
      ConstructJSONNew(data?.payload?.data);
    }
  };
  React.useEffect(() => {
    getEntityTree();
  }, [editId, isAdd, dispatch]);

  const constructFacility = (data) => {
    let resultData__ = [];
    if (Array.isArray(data) && data?.length > 0) {
      data.map((val, i) => {
        resultData__.push({
          OrgType: "Facility",
          checked: val.checked,
          id: val?._id ?? "",
          entity: val?.name ?? "",
          reason: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.reason ?? "",
          status: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.status ?? "",
          holidayDtlsId: val?.holidayDtls?.[0]?.holidayDtls?.[0]?._id ?? "",
        });
      });
    }
    return resultData__;
  };
  const constructOrganization = (data) => {
    let resultData_ = [];
    if (Array.isArray(data) && data?.length > 0) {
      data.map((val, i) => {
        resultData_.push({
          OrgType: "Organization",
          checked: val.checked,
          id: val?._id ?? "",
          entity: val?.name ?? "",
          reason: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.reason ?? "",
          status: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.status ?? "",
          holidayDtlsId: val?.holidayDtls?.[0]?.holidayDtls?.[0]?._id ?? "",
          children:
            Array.isArray(val?.facility) && val?.facility?.length > 0
              ? constructFacility(val?.facility)
              : [],
        });
      });
    }

    return resultData_;
  };
  const ConstructJSONNew = (data) => {
    let resultData = [];
    if (Array.isArray(data) && data?.length > 0) {
      data.map((val, i) => {
        resultData.push({
          OrgType: "Enterprise",
          checked: val.checked,
          id: val?._id ?? "",
          entity: val?.name ?? "",
          reason: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.reason ?? "",
          status: val?.holidayDtls?.[0]?.holidayDtls?.[0]?.status ?? "",
          holidayDtlsId: val?.holidayDtls?.[0]?.holidayDtls?.[0]?._id ?? "",
          children:
            Array.isArray(val?.Organization) && val?.Organization?.length > 0
              ? constructOrganization(val?.Organization)
              : [],
        });
      });
    }
    setTreeListData(resultData);
    let editCheckdata = [];
    EditMaster?.data[0]?.Holidaydtls.map((value) => {
      editCheckdata.push({
        Checked: true,
        orgid: value.orgid,
        status: "CodingMaster/11302",
        reason: "Active",
      });
      setValues([...editCheckdata]);
    });
  };

  useEffect(() => {
    const ids = [];

    if (editId) {
      EditMasters[0]?.HolidayDtls?.map((item) => {
        return ids.push(item?.orgid._key);
      });
      setValueDef(ids);
    }
  }, [editId, treeData]);
  React.useEffect(() => {
    getallmasters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTypeDropdown = (values) => {
    const sortedItems = [...holidayType];

    if (values) {
      sortedItems.sort((a, b) => {
        if (a.label === values.holiday_type) return -1; // a comes before b
        if (b.label === values.holiday_type) return 1; // b comes before a
        return 0; // no change for other labels
      });
      return sortedItems;
    } else {
      const tmpArr = [];
      holidayType?.map((item) => {
        return tmpArr.push({
          label: item.display,
          _id: item._id,
        });
      });
      return tmpArr || [];
    }
  };

  const getHolidayTypeDropdown = async () => {
    try {
      const getHolidayType = await dispatch(actions.GET_HOLIDAY_TYPE());
      setholidayType(getHolidayType?.payload?.data);
    } catch (error) {
      console.error("Error fetching holiday types:", error);
      // Handle error appropriately
    }
  };
  React.useEffect(() => {
    getHolidayTypeDropdown();
  }, []);

  const handleDrawerOpen = () => {
    setview(false);
    setValues([]);

    setThdata([
      {
        Title: "Entity",
      },
    ]);
    setClicked(true);
    setIsAdd(true);
    setId("");

    setState({
      ...state,
      open: true,
    });
    setData([
      {
        componet_type: "yearSelector",
        label: "Calendar Year",
        state_name: "calender_year",
        value: moment().year(),
        required: true,
      },

      {
        componet_type: "date",
        label: "Date",
        state_name: "date",
        value: "",
        dateFormat: "DD-MM-YYYY",
        required: true,
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "select",
        options: holidayType ?? [],
        label: "Holiday Type",
        state_name: "holiday_type",
        value: state?.edit_data?.holiday_type ?? {},
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "text",
        label: "Holiday Reason",
        state_name: "holiday_reason",
        value: state?.edit_data?.holiday_reason ?? "",
        pattern: /^[A-Za-z]+$/,
        grid: {
          md: 3,
        },
      },
      {
        componet_type: "Switch",
        label: "Status",
        state_name: "Status",
        value: state?.edit_data?.Status ?? false,
        defaultChecked: true,
        grid: {
          md: 1,
        },
      },
      // {
      //   componet_type: "entity",
      //   label: " Add Applicable Entity",
      //   grid: {
      //     md: 1,
      //   },
      // },
    ]);
  };
  const handleDrawerClose = () => {
    setEditId("");
    setState({
      ...state,
      open: false,
      edit_data: null,
    });
  };
  React.useLayoutEffect(() => {
    dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,
      })
    );
    dispatch(actions.HOLIDAY_MASTERS());
    // dispatch(actions.ENTITY_MASTERS());
  }, [currentYear, dispatch, page, perPage]);
  const getUtcTime = (date) => {
    if (date) {
      return moment.utc(date).unix();
    } else {
      return moment.utc().unix();
    }
  };

  React.useLayoutEffect(() => {
    dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,
      })
    );
    // dispatch(actions.HOLIDAY_SINGLE_READ_QDM(editId));
    // dispatch(actions.HOLIDAY_MASTERS());
    // dispatch(actions.ENTITY_MASTERS());
  }, [currentYear, dispatch, page, perPage]);
  useEffect(() => {}, [copiedData]);

  // Function to handle the API call and response

  function extractCheckedTrue(objects) {
    let result = [];
    for (let obj of objects) {
      if (obj.holidayDtlsId != "") {
        if (obj.checked === true) {
          result.push({
            _id: obj?.holidayDtlsId ? obj.holidayDtlsId : "",
            Checked: true,
            orgid: obj?.id ? obj.id : "",
            status: obj?.status?._id ? obj.status._id : "CodingMaster/11303",
            reason: obj?.reason?._id ? obj.reason._id : "",
          });
        }
        if (obj.checked === false) {
          result.push({
            _id: obj?.holidayDtlsId ? obj.holidayDtlsId : "",
            Checked: false,
            orgid: obj?.id ? obj.id : "",
            status: obj?.status?._id ? obj.status._id : "CodingMaster/11303",
            reason: obj?.reason?._id ? obj.reason._id : "",
          });
        }
      }
      if (obj.holidayDtlsId == "" && obj.checked === true) {
        result.push({
          Checked: true,
          orgid: obj?.id ? obj.id : "",
          status: obj?.status?._id ? obj.status._id : "CodingMaster/11303",
          reason: obj?.reason?._id ? obj.reason._id : "",
        });
      }

      if (obj.children && obj.children.length > 0) {
        result = result.concat(extractCheckedTrue(obj.children));
      }
    }

    return result;
  }

  const editHolidayDtls = async (objects) => {
    for (let obj of objects) {
      if (obj.Checked == false) {
        let delPayload = {
          db_name: envConfig.REACT_APP_DATABASE_NAME,
          entity: Config.HolidaydtlsEntityName,
          filter: `${Config.HolidaydtlsEntityName}._id == '${obj?._id}'`,
          metadata_dbname: envConfig.REACT_APP_MetadataDB_Name,
        };
        await AxiosCall(delPayload, envConfig.REACT_APP_SOFT_DELETE);
      }
    }
  };

  const HolidayWeekDay = (day) => {
    const matchedItem = GetWeekday?.find((item) => item?.label === day);
    const id = matchedItem ? matchedItem._id : null;
    return id;
  };

  const saveHoliday = async (value) => {
    setDisableSave(true);
    let checkedTrueObjects = extractCheckedTrue(treeListData);
    if (id != "") {
      editHolidayDtls(checkedTrueObjects);
    }
    const EditcheckedTrueObjects = checkedTrueObjects.filter(
      (item) => item.Checked
    );
    if (!controler) {
      setRefresh(!refresh);
      if (copyNewHolidayYear) {
        let newEditedCopyData = [...copiedData];
        newEditedCopyData?.map((val, index) => {
          if (val._key === editId) {
            newEditedCopyData.splice(index, 1, {
              CalYear: value?.CalYear,
              date: val?.date,
              day: val?.day,
              holiday_type: value?.holiday_type?.label,
              holiday_reason: value?.holiday_reason,
              status: value?.Status === true ? true : false,
              holidayDetails: checkedTrueObjects ? checkedTrueObjects : [],
            });
          }
          // return null;
        });
        setCopiedData(newEditedCopyData);
        setCopyNewHolidayYear(false);
      } else {
        let type = "success";
        let data = [
          {
            // CalYear: parseInt(moment(new Date(value.calander_year)).format("YYYY")),
            CalYear: value.calender_year,
            CalDate: getUtcTime(moment(value.date)),
            CalDay: HolidayWeekDay(moment(value.date).format("dddd")),
            HolidayType: value?.holiday_type?._id,
            HolidayReason: value?.holiday_reason,
            status: value?.Status === true ? true : false,
            holidayDetails: checkedTrueObjects ? checkedTrueObjects : [],
          },
        ];
        let dataEdit = [
          {
            CalYear: value.calender_year,
            CalDate: getUtcTime(moment(value.date)),
            CalDay: HolidayWeekDay(moment(value.date).format("dddd")),
            HolidayType: value?.holiday_type?._id,
            HolidayReason: value?.holiday_reason,
            status: value?.Status === true ? true : false,
            holidayDetails: EditcheckedTrueObjects
              ? EditcheckedTrueObjects
              : [],
            _id: id,
          },
        ];
        // if (editId.length) {
        //   data._key = editId;
        // }
        const getJwtToken = localStorage.getItem("token");

        const payload = {
          data: id ? dataEdit : data,
          jwtToken: getJwtToken,
        };

        const upsertdata = await dispatch(actions.HOLIDAY_UPSERT(payload));
        if (upsertdata?.payload?.data?.[0]?.error) {
          // type = ("error", upsertdata?.payload?.data?.message);
          props.alert.setSnack("error", " Holiday Already Exist");
        } else {
          props.alert.setSnack("success");
        }
        await dispatch(
          actions.HOLIDAY_READ_QDM({
            page: page,
            perPage: perPage,
            CalYear: currentYear,

            entity_name: filterData?.entity_name?._id ?? null,
            entity_type: filterData?.entity_type?.value ?? null,
          })
        );
        getEntityTree();
        handleDrawerClose();
        // props.alert.setSnack("error", upsertdata?.payload?.data?.message);
        // setEditId(true);
      }
      setDisableSave(false);
    } else {
      setDisableSave(false);
      setEditId("");
      setControler(false);
      setClicked(false);
      setIsAdd(false);
      setId("");
    }
  };

  const getDatePickerTimeFormat = (val) => {
    // const unixTimestamp = 1575909015;
    const milliseconds = val * 1000; // 1575909015000

    const dateObject = new Date(milliseconds);

    const humanDateFormat = dateObject.toLocaleString();

    return humanDateFormat;
  };

  const handleEdit = (e, values, index) => {
    setview(false);
    setEditId(values._id);
    setValues([]);
    setControler(false);
    setThdata([
      {
        Title: "Entity",
        Size: 7,
      },
      {
        Title: "Status",
        Size: 2,
      },
      {
        Title: "Reason",
        Size: 1,
      },
    ]);
    setState({
      ...state,
      open: true,
    });
    setClicked(true);
    setIsAdd(true);
    // setIsEdit(true);
    const newDate = getDatePickerTimeFormat(values.date);
    dispatch(actions.HOLIDAY_SINGLE_READ_QDM(values?._id));
    setId(values._id);
    let data = {
      ...values,
      repeat: values.repeat === "Yes" ? true : false,
      date: newDate,
      holiday_type: {},
    };
    setState({
      ...state,
      open: true,
      edit_data: data,
    });
    setData([
      {
        componet_type: "yearSelector",
        label: "Calendar Year",
        state_name: "calender_year",
        value: values?.CalYear || moment().year(),
        disabled: true,
      },
      {
        componet_type: "date",
        label: "Date",
        state_name: "date",
        value: convertToEpoch(values?.date) ?? "",
        dateFormat: "DD-MM-YYYY",
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "select",
        options: holidayType ?? [],
        label: "Holiday Type",
        state_name: "holiday_type",
        value: {
          _id: values?.holiday_type?._id,
          value: values?.holiday_type?._id,
          label: values?.holiday_type?.display,
        },
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "text",
        label: "Reason for Holiday",
        state_name: "holiday_reason",
        value: values?.holiday_reason ?? "",
        grid: {
          md: 3,
        },
      },
      {
        componet_type: "Switch",
        label: "Status",
        state_name: "Status",
        value: values?.status === true ? true : false,
        defaultChecked: values?.status === true ? true : false,
        grid: {
          md: 1,
        },
      },
      // {
      //   componet_type: "entity",
      //   label: "Edit Applicable Entity",
      //   grid: {
      //     md: 1,
      //   },
      // },
    ]);
    setShowFacility(true);
  };
  function convertToEpoch(dateString) {
    // Parse the date in DD-MM-YYYY format using moment.js
    const date = moment(dateString, "DD-MM-YYYY");

    // Get the epoch timestamp (milliseconds)
    return date.valueOf();
  }
  const handleView = (e, values, index) => {
    setview(true);
    setEditId(values._id);
    setValues([]);
    setControler(false);
    setThdata([
      {
        Title: "Entity",
        Size: 7,
      },
      {
        Title: "Status",
        Size: 2,
      },
      {
        Title: "Reason",
        Size: 1,
      },
    ]);
    setState({
      ...state,
      open: true,
    });
    setClicked(true);
    setIsAdd(true);
    // setIsEdit(true);
    const newDate = getDatePickerTimeFormat(values.date);
    dispatch(actions.HOLIDAY_SINGLE_READ_QDM(values?._id));
    setId(values._id);
    let data = {
      ...values,
      repeat: values.repeat === "Yes" ? true : false,
      date: newDate,
      holiday_type: {},
    };
    setState({
      ...state,
      open: true,
      edit_data: data,
    });
    setData([
      {
        componet_type: "yearSelector",
        label: "Calendar Year",
        state_name: "calender_year",
        value: values?.CalYear || moment().year(),
        disabled: true,
      },
      {
        componet_type: "date",
        label: "Date",
        state_name: "date",
        value: convertToEpoch(values?.date) ?? "",
        dateFormat: "DD-MM-YYYY",
        disabled: true,
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "select",
        options: holidayType ?? [],
        label: "Holiday Type",
        state_name: "holiday_type",
        disabled: true,
        value: {
          _id: values?.holiday_type?._id,
          value: values?.holiday_type?._id,
          label: values?.holiday_type?.display,
        },
        grid: {
          md: 2,
        },
      },
      {
        componet_type: "text",
        label: "Reason for Holiday",
        state_name: "holiday_reason",
        value: values?.holiday_reason ?? "",
        disabled: true,
        grid: {
          md: 3,
        },
      },
      {
        componet_type: "Switch",
        label: "Status",
        state_name: "Status",
        value: values?.status === true ? true : false,
        defaultChecked: values?.status === true ? true : false,
        disabled: true,
        grid: {
          md: 1,
        },
      },
      // {
      //   componet_type: "entity",
      //   label: "Edit Applicable Entity",
      //   grid: {
      //     md: 1,
      //   },
      // },
    ]);
    setShowFacility(true);
  };

  /**
   *
   */
  const handleshowData = () => {
    setClicked(true);
    setIsAdd(true);
    // setEditId("");
    setShowStatus(true);
    setControler(true);
  };

  const statusChange = async (e, values, index) => {
    alert("test");
    let data = {
      _key: values._key,
      status: e.target.checked,
    };
    await dispatch(actions.HOLIDAY_STATUS_CHANGE(data));
    await dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,

        entity_name: filterData?.entity_name?._id ?? null,
        entity_type: filterData?.entity_type?.value ?? null,
      })
    );
    setState({
      ...state,
      edit_data: null,
      open: true,
    });
    props.alert.setSnack("update");
  };

  // old state

  const changeState = (key, value) => {
    if (key === "entity_type" && value?.value) {
      props.GET_ENTITY_BY_ID({ id: value.value });
      filterData.entity_name = {};
    }
    if (key === "entity_type") {
      filterData.entity_name = {};
    }
    filterData[key] = value;
    if (filterData?.entity_name?._id && filterData?.entity_type?.value) {
      dispatch(
        actions.HOLIDAY_READ_QDM({
          page: page,
          perPage: perPage,
          CalYear: currentYear,

          entity_name: filterData?.entity_name?._id,
          entity_type: filterData?.entity_type?.value,
        })
      );
    } else {
      dispatch(
        actions.HOLIDAY_READ_QDM({
          page: page,
          perPage: perPage,
          CalYear: currentYear,
        })
      );
    }
    setFilterData({ ...filterData });
  };

  // const [entity, setentity] = React.useState(true);

  // const handleshow = () => {
  //   setFilterData({
  //     entity_type: {},
  //     entity_name: {},
  //   });
  //   setshow(true);
  //   setentity(false);
  // };
  const handlehide = () => {
    setFilterData({
      entity_type: {},
      entity_name: {},
    });
    setshow(false);
    // setentity(true);
    dispatch(
      actions.HOLIDAY_READ_QDM({
        page: page,
        perPage: perPage,
        CalYear: currentYear,
      })
    );
  };

  const onSearchChange = (value = "") => {
    if (value?.length > 1) {
      dispatch(
        actions.HOLIDAY_READ_QDM({
          search: value.trim(),
          page: page,
          perPage: perPage,
          CalYear: currentYear,
        })
      );
    } else if (!value) {
      dispatch(
        actions.HOLIDAY_READ_QDM({
          page: page,
          perPage: perPage,
          CalYear: currentYear,
        })
      );
    }
  };
  const handleModalOpenNew = () => {
    setConfirmCalenderYear({
      ...calendarYear,
      open: true,
    });
  };
  const handleDrawerCloseNew = () => {
    setConfirmCalenderYear({
      ...calendarYear,
      open: false,
    });
  };
  const onConfirmHoliday = async (value) => {
    setCopyNewHolidayYear(true);
    setCopyYear(parseInt(moment(value.calander_year).format("YYYY")));
    handleDrawerCloseNew();
    await dispatch(
      actions.HOLIDAY_READ_QDM({
        CalYear: currentYear,
        page: page,
        perPage: perPage,
      })
    );
    setCopiedData(listData);
  };
  const getDataList = () => {
    if (copiedData.length) {
      return copiedData;
    }
    return listData;
  };
  const onConfirmation = () => {
    const TypeDropdown = getTypeDropdown();

    let finalCopyData = [];

    listData[0]?.copyData?.map((value, index) => {
      return finalCopyData.push({
        CalYear: moment().year() + 1,
        CalDate: value.CalDate,
        CalDay: value._id,
        HolidayType:
          TypeDropdown.filter(
            (val) => val.label === copiedData[index]?.holiday_type
          ) &&
          TypeDropdown.filter(
            (val) => val.label === copiedData[index]?.holiday_type
          )[0]
            ? TypeDropdown.filter(
                (val) => val.label === copiedData[index]?.holiday_type
              )[0]?._id
            : null,
        //value.HolidayType._id,
        HolidayReason: copiedData[index]?.holiday_reason,
        status: true,
        holidayDetails: [],
      });
    });
    setCopyYearData(finalCopyData);
    setCopyNewHolidayYear(false);
    let type = "success";
    props.alert.setSnack(type);
  };
  /**
   *
   */
  const prevYear = () => {
    setCurrentYear(currentYear - 1);
  };
  /**
   *
   */
  const nextYear = () => {
    setCurrentYear(currentYear + 1);
  };
  const handleDelete = (e, values, index) => {
    let newEditedCopyData = [...copiedData];
    newEditedCopyData.splice(index, 1);
    setCopiedData(newEditedCopyData);
  };
  return (
    <div id={`${parent_id}-parent-div`} style={{ borderRadius: "12px" }}>
      <div id={`${parent_id}-parent-sub-div`} style={{ width: "100%" }}>
        {show && (
          <div id={`${parent_id}-parent-sub-div`} style={{ marginBottom: 14 }}>
            <Row id={`${parent_id}-parent-row`}>
              <Col
                id={`${parent_id}-expandarrow-col`}
                xs={2}
                sm={2}
                md={2}
                lg={2}
                xl={2}
                inLineStyles={{ padding: 0 }}
              >
                <button
                  id={`${parent_id}-expandarrow-button`}
                  className={classes.leftButton}
                  onClick={() => handlehide()}
                >
                  <img
                    id={`${parent_id}-expandarrow-img`}
                    src={expandarrow}
                    alt="icon"
                    style={{ transform: "rotate(90deg)", width: 14 }}
                  />
                </button>
              </Col>
              <Col
                id={`${parent_id}-parent-col`}
                xs={10}
                sm={10}
                md={10}
                lg={10}
                xl={10}
                inLineStyles={{ padding: 0 }}
              >
                <Row
                  id={`${parent_id}-parent-sub-row`}
                  style={{ justifyContent: "flex-end" }}
                >
                  <Col
                    id={`${parent_id}-FilterSelect-col`}
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    inLineStyles={{ padding: "0px 0px 0px 8px" }}
                  >
                    <FilterSelect
                      parent_id={"entity-type"}
                      value={filterData?.entity_type}
                      onChange={(value) => changeState("entity_type", value)}
                      options={allMasters?.["entity"] ?? []}
                      label="Entity Type :"
                    />
                  </Col>
                  <Col
                    id={`${parent_id}-FilterSelect-col`}
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    xl={4}
                    inLineStyles={{ padding: "0px 0px 0px 8px" }}
                  >
                    <FilterSelect
                      parent_id={"entity-name"}
                      value={filterData?.entity_name}
                      onChange={(value) => changeState("entity_name", value)}
                      options={props?.entity_name_options ?? []}
                      label="Entity Name :"
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
        <Card id={`${parent_id}-parent-card`} style={{ borderRadius: "12px" }}>
          <div
            id={`${parent_id}-parent-div`}
            style={{
              borderRadius: "6px",
            }}
          >
            <div
              container
              item
              md={12}
              id={`${parent_id}-discription-sub-div`}
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 20px",
                borderBottom: "1px solid lightgray",
              }}
            >
              <div id={`${parent_id}-List-of-Holidays-div`}>
                <p
                  id={`${parent_id}-List-of-Holidays-title-p`}
                  style={{
                    fontFamily: "poppinsemibold",
                    fontSize: "16px",
                    paddingTop: "12px",
                  }}
                >
                  {copyNewHolidayYear
                    ? `Copying Calendar year from ${
                        copyYear - 1
                      } to ${copyYear}`
                    : "Holidays"}
                </p>
              </div>
              {!copyNewHolidayYear && (
                <div style={{ paddingTop: "20px" }}>
                  <YearPicker
                    label="Calendar Year"
                    currentYear={currentYear}
                    prevYear={prevYear}
                    nextYear={nextYear}
                  />
                </div>
              )}
              <div
                id={`${parent_id}-entity-div`}
                style={{ marginTop: "16px", float: "right", display: "flex" }}
              >
                {/* {!copyNewHolidayYear && (
                  <SearchWithFilter
                    id="Holiday"
                    placeholder="Search by entity,holiday type & holiday reason"
                    onSearchChange={onSearchChange}
                    hideSearchBar={false}
                    hideFilter={true}
                  />
                )} */}
                {/* <CustomTooltip /> */}

                {copyNewHolidayYear ? (
                  <div>
                    <p
                      style={{
                        fontFamily: "poppinsemibold",
                        fontSize: "16px",
                      }}
                    >
                      Calendar Year : {copyYear}
                    </p>
                  </div>
                ) : (
                  <div>
                    <Button
                      id={`${parent_id}-Add-New-button`}
                      disabled={
                        show
                          ? filterData?.entity_type?.value &&
                            filterData?.entity_name?.value
                            ? false
                            : true
                          : false
                      }
                      variant={"contained"}
                      onClick={handleDrawerOpen}
                      className={classes.saveBtn}
                      style={{
                        "&.MuiButton-contained": {
                          "&:hover": {
                            backgroundColor: "#0071f2 !important",
                          },
                        },
                      }}
                    >
                      +Add Holiday
                    </Button>
                  </div>
                )}
                <GenerateFormVersion2
                  parent_id={"holidaytable"}
                  loading={saveloading}
                  open={state.open}
                  save={saveHoliday}
                  handlecancel={handleDrawerClose}
                  header={state.edit_data ? "Edit Holiday" : "Add New Holiday"}
                  json={data}
                  handleshow={handleshowData}
                  nocancel
                  isAdd={isAdd}
                  setIsAdd={setIsAdd}
                  modalStructure={
                    isAdd ? classes.entityAdd : classes.addNewModal
                  }
                  isEditHoliday={showFacility}
                  nosave={false}
                  clicked={clicked}
                  showStatus={showStatus}
                  treeListData={treeListData}
                  setTreeListData={setTreeListData}
                  setValues={setValues}
                  values={values}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  refresh={refresh}
                  Thdata={Thdata}
                  controler={controler}
                  view={view}
                  disableSave={disableSave}
                />
              </div>
            </div>
            <div id={`${parent_id}-CommonTable-div`} style={{ padding: 20 }}>
              <CommonTable
                parent_id={"holidaytable"}
                Header={[
                  "S.No",
                  "Date",
                  "Day",
                  "Holiday Type",
                  "Holiday Reason",
                  "Status",
                  "Action",
                ]}
                customStyles={[
                  {
                    key: "Holiday Reason",
                    styles: {
                      width: "538px",
                    },
                  },
                  {
                    key: "Status ",
                    styles: {
                      width: "70px",
                    },
                  },
                  {
                    key: "Action  ",
                    styles: {
                      width: "70px",
                    },
                  },
                ]}
                dataList={getDataList()}
                tableData={[
                  { type: ["INCRIMENT"], name: "" },
                  { type: ["TEXT"], name: "date" },
                  { type: ["TEXT"], name: "day" },
                  {
                    type: ["TEXT"],
                    name: "holiday_type",
                    optionLabel: "display",
                  },
                  { type: ["TEXT"], name: "holiday_reason" },

                  { type: ["STATUS"], name: "status" },
                  {
                    type: copyNewHolidayYear ? ["COPYACTION"] : ["ACTION"],
                    name: "action",
                  },
                ]}
                // handleCheckBox={statusChange}
                handleEdit={handleEdit}
                handleView={handleView}
                handlepageChange={(currentPage, PerPage) =>
                  handlepageChange(currentPage, PerPage)
                }
                TableCount={getDataList()?.[0]?.TotalCountByYear}
                incrementCount={page}
                showPagination={true}
                rowsPerPageOptions={[
                  { label: "10 Rows", value: 10 },
                  { label: "50 Rows", value: 50 },
                  { label: "100 Rows", value: 100 },
                ]}
                handleDelete={handleDelete}
              />
            </div>
            <div className={classes.footer}>
              <button
                id={`${parent_id}-entity-button`}
                className={
                  copyNewHolidayYear ? classes.confirmNote : classes.copyNote
                }
                onClick={handleModalOpenNew}
              >
                <div
                  id={`${parent_id}-View-holidays-entities-div`}
                  style={{ display: "flex" }}
                >
                  {/* <div
                    id={`${parent_id}-View-holidays-entities-sub-div`}
                    className={classes.noteDiv}
                  >
                    {copyNewHolidayYear
                      ? "Note: Edit (or) Delete holidays as per the new calender year"
                      : "Copy Holidays to New Calendar Year"}
                  </div> */}
                </div>
              </button>
              {copyNewHolidayYear && (
                <Button
                  id={`${parent_id}_generateform_Save_button`}
                  disabled={props?.loading ?? false}
                  variant={"contained"}
                  className={classes.saveBtn}
                  size={"small"}
                  contained
                  onClick={() => onConfirmation()}
                  disableElevation
                >
                  Confirm & Save
                </Button>
              )}
            </div>
            <Grid width="27%">
              <GenerateFormVersion2
                parent_id={"copyholidaytable"}
                loading={saveloading}
                open={calendarYear.open}
                save={(data) => {
                  onConfirmHoliday(data);
                }}
                treeListData={treeListData}
                handlecancel={handleDrawerCloseNew}
                header="Copy to Calendar Year"
                json={[
                  {
                    componet_type: "yearSelector",
                    dateFormat: "yyyy",
                    label: "Select the year to copy",
                    state_name: "calander_year",
                    value: moment().year(),
                    className: classes.pickYear,
                  },
                ]}
                modalStructure={classes.copyYearModal}
                nosave
                handleClick={() => onConfirmHoliday()}
                clicked={clicked}
                editId={editId}
              />
            </Grid>
          </div>
        </Card>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  practitioner_masters: state?.practitionerMasterSlice?.practitioner_masters,
  entity_name_options: state?.practitionerSlice?.get_entity_by_id?.data ?? [],
});

export default connect(
  mapStateToProps,
  actions
)(withAllContexts(HolidayTableVersion2));
